import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[wmLibsDigitsOnly]',
  standalone: true,
})
export class DigitsOnlyDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event']) onInput(e: KeyboardEvent) {
    if (e.code === 'Period') {
      const value = '';
      if (value.indexOf('.') !== -1) {
        e.preventDefault();
        return;
      }
    }

    if (
      ['Enter', 'Tab', 'Backspace', 'Escape', 'Enter'].indexOf(e.code) !== -1 ||
      (e.code === 'KeyA' && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.code === 'KeyC' && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.code === 'KeyV' && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.code === 'KeyX' && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.code === 'KeyA' && e.metaKey === true) || // Cmd+A (Mac)
      (e.code === 'KeyC' && e.metaKey === true) || // Cmd+C (Mac)
      (e.code === 'KeyV' && e.metaKey === true) || // Cmd+V (Mac)
      (e.code === 'KeyX' && e.metaKey === true) || // Cmd+X (Mac)
      e.code === 'ArrowRight' || // right
      e.code === 'ArrowLeft' // left
    ) {
      return;
    }

    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedInput: string =
      event.clipboardData?.getData('text/plain').replace(/\D/g, '') || '';
    document.execCommand('insertText', false, pastedInput);
  }

  // Temp fix for safari
  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    const textData = event?.dataTransfer?.getData('text').replace(/\D/g, '');
    this.el.nativeElement.focus();
    document.execCommand('insertText', false, textData);
  }
}
